module.exports = __webpack_public_path__ + "static/media/SJ.ed7007a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SJ.svg
// module id = 2259
// module chunks = 7